// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b03e3c98","732":"afc276df","977":"dbdfc344"}[chunkId] + ".chunk.js";
};